<template>
<!-- 对接详情嘉宾 -->
  <div class="DockingDetailsCenterHonoredGuest">
      <DockingSystemTitle :title="'嘉宾'" :underlineType="true" :moreType="false" :titleCenter="true"/>
      <div class="content">
          <el-row class="contentUl" style="color:#fff">
            
            <el-col :xs="12" :sm="6" class="contentLi" v-for="(item,index) in list" :key="index">
                <div class="img">
                    <img class="cover" :src="item.coverurl" alt="">
                </div>
                <div class="text">
                    <div class="title">{{item.realname}}</div>
                    <p class="company">{{item.companyname}}</p>
                    <p class="position">{{item.positionname}}</p>
                </div>
            </el-col>
            

        </el-row>
      </div>
      <!-- <div class="main">
      <el-row style="color:#fff">
        <el-col :xs="12" :sm="6">111</el-col>
        <el-col :xs="12" :sm="6">222</el-col>
        <el-col :xs="12" :sm="6">333</el-col>
        <el-col :xs="12" :sm="6">444</el-col> 
      </el-row>
    </div> -->
    <!-- logoUrl: "../../../../public/static/images/honoredGuest1.png", -->
  </div>
</template>

<script>
import DockingSystemTitle from "@/components/DockingSystem/Title/DockingSystemTitle.vue"; //对接详情嘉宾Title

export default {
    props:{
        list:Array,//嘉宾信息
    },
    components:{
        DockingSystemTitle,
    },
    data(){
        return{

        }
    },
    created:function(){

    },
    methods:{},

}
</script>

<style scoped>
@media (max-width: 768px) {
  /* .DockingDetailsCenterHonoredGuest{
    margin-left: 10px;
    margin-right: 10px;
  } */
  .DockingDetailsCenterHonoredGuest{
      margin-left: 0px !important;
  }
  .DockingDetailsCenterHonoredGuest .content{
      margin-left: 0px;
      margin-right: 0px;
  }
  .DockingDetailsCenterHonoredGuest .position{
      height: 38px;
      padding:0 5px;
  }
}

.DockingDetailsCenterHonoredGuest{
    background-color: #1d1d1f;
	border-radius: 25px;
    margin-top: 40px;
    margin-left: 7px;
}
.content{
    margin: 0 68px;
    margin-top: 48px;
    padding-bottom: 37px;
}
.contentUl{

}
.contentLi{
    text-align: center;
    margin-bottom: 20px;
}

.cover{
    width: 150px;
	height: 150px;
    border-radius: 50%;
    margin: 0 auto;
}
.text{
    margin-top:25px ;
}
.text > p{
    
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #b5b5b7;
}
.title{
    
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 1px;
	color: #ffffff;
}
.company{
    margin-top: 13px;
}
.position{
    margin-top: 6px;

}
</style>